module.exports = __webpack_public_path__ + "static/media/credibility.dc11b8d0.svg";